import clsx from 'clsx';
import React from 'react';

import FlexLink from '@components/FlexLink';
import { new_forum_post_path } from '@routes';

import styles from './styles.module.scss';

export default function NewForumPostButton() {
  return (
    <div className={styles.writePostBtnWrapper}>
      <FlexLink href={new_forum_post_path()} className={clsx(styles.btn, styles.writePostBtn)}>
        Write a Post
      </FlexLink>
    </div>
  );
}
